import { gql, useQuery } from '@apollo/client'
import { ProductBrand } from '@@partner:types:app'

export interface ProductAvailableBrandsQuery {
  brands: ProductBrand[]
}

export interface ProductAvailableBrandsQueryVariables {
  name: string
}

export const GQL_QUERY_PRODUCT_AVAILABLE_BRANDS = gql`
  query($name: String!) {
    brands: productAvailableBrands(name: $name) {
      id
      name
    }
  }
`

export const useFetchQuery = (
  variables: ProductAvailableBrandsQueryVariables
) => {
  return useQuery<
    ProductAvailableBrandsQuery,
    ProductAvailableBrandsQueryVariables
  >(GQL_QUERY_PRODUCT_AVAILABLE_BRANDS, {
    variables,
    skip: variables.name.length < 1
  })
}
